import React, {useRef, useState} from 'react';
import {Button, Divider, Alert} from 'antd';
import './style.css';
import {formatCurrencyByLocalChapter} from '../../../Util/commonUtility';
import useLocalization from '../../../Localization';

const ConfirmationAction = ({
  heading,
  onConfirm,
  onCancel,
  data,
  submitName,
  totalCartPrice,
  usedForAddAttendees,
  usedForSponsor = false,
  disable = false,
  extra = false,
  usedForCart = false,
  eventLocalChapterData,
}) => {
  const {ApplicationString} = useLocalization();
  const [isConfirming, setIsConfirming] = useState(false);
  const isConfirmingRef = useRef(false);

  const handleConfirm = async () => {
    if (isConfirmingRef.current || disable) return;
    isConfirmingRef.current = true;
    setIsConfirming(true);
    try {
      await onConfirm?.();
    } finally {
      isConfirmingRef.current = false;
      setIsConfirming(false);
    }
  };

  return (
    <div className='main-container-payment'>
      <div
        className={`extra-message ${
          usedForCart
            ? totalCartPrice?.refund_credit
              ? 'extra-message-cart-left-credit'
              : 'extra-message-cart-left'
            : 'extra-message-left'
        }`}>
        {extra && (
          <div className='attendees-description-container'>
            <Alert
              prefixCls='attendees-description-alert'
              message={<div dangerouslySetInnerHTML={{__html: extra}} />}
              type='info'
            />
          </div>
        )}
      </div>
      <div className='main-confirmation-content-container'>
        <div className='confirmation-container confirmation-max-width action-con'>
          <div
            className={`${
              totalCartPrice?.refund_credit
                ? 'price-container-credit'
                : 'price-container'
            } `}>
            <div>
              {totalCartPrice?.discount || totalCartPrice?.refund_credit ? (
                <div>
                  <div className='discount-price-container'>
                    <label className='price-label'>
                      {
                        ApplicationString[
                          'userAttendeeCartComponent.credit.subtotal'
                        ]
                      }
                      :{' '}
                    </label>
                    <p className='price-txt'>
                      {formatCurrencyByLocalChapter(
                        totalCartPrice?.total_price_per_cart,
                        eventLocalChapterData,
                      )}
                    </p>
                  </div>
                  {totalCartPrice?.discount ? (
                    <div className='discount-price-container'>
                      <label className='price-label'>
                        {
                          ApplicationString[
                            'userAttendeeCartComponent.credit.discount'
                          ]
                        }
                        :{' '}
                      </label>
                      <p className='price-txt line-break'>
                        {formatCurrencyByLocalChapter(
                          totalCartPrice?.discount,
                          eventLocalChapterData,
                        )}
                      </p>
                    </div>
                  ) : null}
                  {totalCartPrice?.refund_credit ? (
                    <div className='discount-price-container'>
                      <label className='price-label'>
                        {
                          ApplicationString[
                            'userAttendeeCartComponent.credit.useCredit'
                          ]
                        }
                        :{' '}
                      </label>
                      <p className='price-txt line-break'>
                        {formatCurrencyByLocalChapter(
                          usedForSponsor
                            ? totalCartPrice?.refund_credit
                            : totalCartPrice?.refund_credit_for_regular_attendees,
                          eventLocalChapterData,
                        )}
                      </p>
                    </div>
                  ) : null}
                  <Divider prefixCls='price-cart-divider' />
                  <div className='discount-price-container'>
                    <label className='price-label total-text-cart total-blue'>
                      {
                        ApplicationString[
                          'userAttendeeCartComponent.credit.totalAmountToBePaid'
                        ]
                      }
                    </label>
                    <p className='price-txt final-price'>
                      {formatCurrencyByLocalChapter(
                        totalCartPrice?.discounted_price,
                        eventLocalChapterData,
                      )}
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  className={`${
                    usedForAddAttendees && 'attendees-text'
                  }  price-txt`}>
                  <p>
                    {formatCurrencyByLocalChapter(
                      totalCartPrice?.total_price_per_cart,
                      eventLocalChapterData,
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>

          <Button
            className='confirmation-action-button'
            prefixCls='proceedToPayBtn'
            type='primary'
            onClick={handleConfirm}
            loading={isConfirming}
            disabled={disable || isConfirming}
            // disabled={!data || data?.length === 0}
          >
            {submitName}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationAction;
